import React from 'react'
import profileDefault from "../../../assets/profile_default.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RattingPage from './RattingCommanPage';
import { Card } from 'react-bootstrap';
import moment from 'moment';

export default function ReviewListPage(props) {

  return (
    <Card className="review-list card">
        <Card.Body >
            <div className="user-detail">
                    <LazyLoadImage
                        alt=""
                        src={
                        props?.item?.user_details?.image_url === null
                            ? profileDefault
                            : props?.item?.user_details?.image_url
                        }
                    />
                    <div className='innner_details_user'>
                        <div className="user-rating">
                                <h6>{props?.item?.user_details?.first_name}</h6>
                                <label>
                                    {moment(props?.item?.created_at).format("DD-MM-YYYY hh:mm A")}
                                </label>                            
                        </div>
                        <div  className={"star_rating"}>
                        <RattingPage
                            initialValue={props?.item.rating}
                            readonly={true}
                            size={16}
                            fillColor={"var(--pr-color)"}
                        />
                        </div>
                        <p>{props?.item.review}</p>
                    </div>
            </div>
        </Card.Body>
    </Card>
  )
}
